import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { spakinectQueryOptions } from "@/api/spakinect/gfe";

/**
 * Composes the treatments query and favorites query.
 * When favorites exist, returns only matching treatments.
 * When no favorites are set, returns all treatments (backwards-compatible).
 */
export function useSpaKinectTreatments(t0) {
  const $ = _c(26);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = spakinectQueryOptions.treatments();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== enabled) {
    t2 = {
      ...t1,
      enabled
    };
    $[1] = enabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: treatmentsData,
    isLoading: loadingTreatments
  } = useQuery(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = spakinectQueryOptions.favoriteTreatments();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== enabled) {
    t4 = {
      ...t3,
      enabled
    };
    $[4] = enabled;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data: favorites,
    isLoading: loadingFavorites
  } = useQuery(t4);
  const hasFavorites = (favorites?.length ?? 0) > 0;
  let t5;
  bb0: {
    if (!treatmentsData) {
      let t6;
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
          treatments: [],
          treatmentOptions: []
        };
        $[6] = t6;
      } else {
        t6 = $[6];
      }
      t5 = t6;
      break bb0;
    }
    if (!hasFavorites) {
      t5 = treatmentsData;
      break bb0;
    }
    let t6;
    if ($[7] !== favorites) {
      t6 = new Set(favorites);
      $[7] = favorites;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    const favoritesSet = t6;
    let t7;
    if ($[9] !== favoritesSet || $[10] !== treatmentsData.treatments) {
      let t8;
      if ($[12] !== favoritesSet) {
        t8 = t => favoritesSet.has(t.name);
        $[12] = favoritesSet;
        $[13] = t8;
      } else {
        t8 = $[13];
      }
      t7 = treatmentsData.treatments.filter(t8);
      $[9] = favoritesSet;
      $[10] = treatmentsData.treatments;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    const treatments = t7;
    let t8;
    if ($[14] !== favoritesSet || $[15] !== treatmentsData.treatmentOptions) {
      let t9;
      if ($[17] !== favoritesSet) {
        t9 = o => favoritesSet.has(o.value);
        $[17] = favoritesSet;
        $[18] = t9;
      } else {
        t9 = $[18];
      }
      t8 = treatmentsData.treatmentOptions.filter(t9);
      $[14] = favoritesSet;
      $[15] = treatmentsData.treatmentOptions;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    const treatmentOptions = t8;
    let t9;
    if ($[19] !== treatmentOptions || $[20] !== treatments) {
      t9 = {
        treatments,
        treatmentOptions
      };
      $[19] = treatmentOptions;
      $[20] = treatments;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t5 = t9;
  }
  const filtered = t5;
  const t6 = loadingTreatments || loadingFavorites;
  let t7;
  if ($[22] !== filtered || $[23] !== hasFavorites || $[24] !== t6) {
    t7 = {
      ...filtered,
      isLoading: t6,
      hasFavorites
    };
    $[22] = filtered;
    $[23] = hasFavorites;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}